import { createContext } from "react";

export const DepartamentosContext = createContext()
export const DepartamentosFormContext = createContext()
export const DepartamentosReportContext = createContext()